import { render } from "./features-carousel.vue?vue&type=template&id=6485419f&scoped=true"
import script from "./features-carousel.vue?vue&type=script&lang=js"
export * from "./features-carousel.vue?vue&type=script&lang=js"

import "./features-carousel.vue?vue&type=style&index=0&id=6485419f&scoped=true&lang=css"

import exportComponent from "/home/rowen/www/html/catholic-club-fleet-base/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6485419f"]])

export default __exports__